import React from "react";

/**
 * Набор собственных SVG-иконок Рублокса. Заменяют эмодзи по всему сайту.
 * Все иконки нарисованы в едином стиле: viewBox 24×24, обводка currentColor,
 * stroke-width 1.8, скруглённые концы. Цвет наследуется от текста (currentColor),
 * так что иконку можно красить через CSS `color`.
 *
 * Использование:  <Icon name="windows" size={40} />
 */

const STROKE = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

/* каждая иконка — функция, возвращающая содержимое <svg> */
const ICONS = {
  /* ── платформы ─────────────────────────────────────────────── */
  windows: () => (
    <>
      <path d="M3 5.6 10.4 4.5v6.6H3z" {...STROKE} />
      <path d="M10.4 4.4 21 3v8.1H10.4z" {...STROKE} />
      <path d="M3 12.9h7.4v6.5L3 18.4z" {...STROKE} />
      <path d="M10.4 12.9H21V21l-10.6-1.5z" {...STROKE} />
    </>
  ),
  android: () => (
    <>
      <path
        d="M5 17v-4.5a7 7 0 0 1 14 0V17a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1Z"
        {...STROKE}
      />
      <path d="M8 7 6.5 4.7M16 7l1.5-2.3" {...STROKE} />
      <circle cx="9.2" cy="11.5" r="1" fill="currentColor" stroke="none" />
      <circle cx="14.8" cy="11.5" r="1" fill="currentColor" stroke="none" />
      <path d="M8.5 18v2.4M15.5 18v2.4" {...STROKE} />
    </>
  ),
  apple: () => (
    <>
      <path
        d="M16.3 12.6c0-2.3 1.9-3.4 2-3.5-1.1-1.6-2.8-1.8-3.4-1.9-1.4-.1-2.8.9-3.5.9s-1.8-.9-3-.8c-1.5 0-2.9.9-3.7 2.3-1.6 2.7-.4 6.8 1.1 9 .8 1.1 1.6 2.3 2.8 2.2 1.1 0 1.5-.7 2.9-.7s1.7.7 2.9.7c1.2 0 2-1.1 2.7-2.2.6-.8.8-1.5 1.1-2.3-2.4-.9-2.5-3.4-2.5-3.7Z"
        {...STROKE}
      />
      <path d="M13.4 5.3c.6-.8 1-1.8.9-2.9-.9 0-2 .6-2.6 1.4-.6.7-1 1.7-.9 2.7 1 .1 2-.5 2.6-1.2Z" {...STROKE} />
    </>
  ),

  /* ── фичи / контент ───────────────────────────────────────── */
  gamepad: () => (
    <>
      <path
        d="M7 8h10a4 4 0 0 1 4 4v.6c0 2-1.2 3.9-3.4 3.9-1.5 0-2.1-1-3-2.2-.4-.5-.9-.8-1.6-.8h-2c-.7 0-1.2.3-1.6.8-.9 1.2-1.5 2.2-3 2.2C3.7 16.5 2.5 14.6 2.5 12.6V12a4 4 0 0 1 4-4Z"
        {...STROKE}
      />
      <path d="M7.5 11v2.4M6.3 12.2h2.4" {...STROKE} />
      <circle cx="15.7" cy="11.4" r="1" fill="currentColor" stroke="none" />
      <circle cx="17.6" cy="13.2" r="1" fill="currentColor" stroke="none" />
    </>
  ),
  wrench: () => (
    <>
      <path
        d="M14.7 6.3a3.9 3.9 0 0 0-5 5l-6 6a1.7 1.7 0 0 0 2.4 2.4l6-6a3.9 3.9 0 0 0 5-5l-2.4 2.4-2.4-.6-.6-2.4 2.4-2.4Z"
        {...STROKE}
      />
    </>
  ),
  noDonate: () => (
    <>
      <circle cx="12" cy="12" r="8.5" {...STROKE} />
      <path d="M6 6 18 18" {...STROKE} />
      <path d="M12 7.5v1.2M12 15.3v1.2" {...STROKE} />
      <path
        d="M14 9.4c-.4-.8-1.2-1.1-2.2-1.1-1.3 0-2.3.7-2.3 1.8 0 2.6 4.8 1.4 4.8 4 0 1.2-1.1 1.9-2.5 1.9-1.1 0-2-.4-2.4-1.2"
        {...STROKE}
      />
    </>
  ),

  /* ── альфа-чипы ───────────────────────────────────────────── */
  bug: () => (
    <>
      <rect x="7.5" y="8.5" width="9" height="9" rx="4.5" {...STROKE} />
      <path d="M9.5 7.5a2.5 2.5 0 0 1 5 0" {...STROKE} />
      <path d="M7.5 11.5H4M16.5 11.5H20M7.6 15H4.4M16.4 15H19.6M8 9 5.5 6.7M16 9l2.5-2.3M8 17.5 5.7 19.6M16 17.5l2.3 2.1" {...STROKE} />
      <path d="M12 9.5v6.5" {...STROKE} />
    </>
  ),
  refresh: () => (
    <>
      <path d="M20 11.5a8 8 0 0 0-13.7-5L4 9" {...STROKE} />
      <path d="M4 4.5V9h4.5" {...STROKE} />
      <path d="M4 12.5a8 8 0 0 0 13.7 5L20 15" {...STROKE} />
      <path d="M20 19.5V15h-4.5" {...STROKE} />
    </>
  ),
  rocket: () => (
    <>
      <path
        d="M12 3c3.5 1.8 5.5 5 5.5 9l-2.3 2.3H8.8L6.5 12C6.5 8 8.5 4.8 12 3Z"
        {...STROKE}
      />
      <circle cx="12" cy="9" r="1.6" {...STROKE} />
      <path d="M8.8 14.3 6.5 16.5M15.2 14.3l2.3 2.2" {...STROKE} />
      <path d="M9.5 17c-1 .6-1.7 1.9-1.8 4 2.1-.1 3.4-.8 4-1.8M14.5 17c1 .6 1.7 1.9 1.8 4-2.1-.1-3.4-.8-4-1.8" {...STROKE} />
    </>
  ),

  /* ── мелкие UI ────────────────────────────────────────────── */
  close: () => <path d="M6 6 18 18M18 6 6 18" {...STROKE} />,
  play: () => (
    <path d="M8 5.5 18 12 8 18.5z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" fill="currentColor" />
  ),
  heart: () => (
    <path
      d="M12 20s-7-4.3-7-9.4A4.1 4.1 0 0 1 12 7.6 4.1 4.1 0 0 1 19 10.6c0 5.1-7 9.4-7 9.4Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
      fill="currentColor"
    />
  ),
  diamond: () => (
    <>
      <path
        d="M6 4h12l3 4.5-9 11.5L3 8.5 6 4Z"
        {...STROKE}
      />
      <path d="M3 8.5h18M9 4 7.5 8.5 12 20M15 4l1.5 4.5L12 20" {...STROKE} />
    </>
  ),
  download: () => (
    <>
      <path d="M12 4v10" {...STROKE} />
      <path d="M8 10.5 12 14.5 16 10.5" {...STROKE} />
      <path d="M5 17v1.5A1.5 1.5 0 0 0 6.5 20h11a1.5 1.5 0 0 0 1.5-1.5V17" {...STROKE} />
    </>
  ),
};

export default function Icon({ name, size = 24, className = "", ...rest }) {
  const render = ICONS[name];
  if (!render) {
    // неизвестное имя — рисуем пустой квадрат-плейсхолдер вместо краша
    return null;
  }
  return (
    <svg
      className={`rb-icon ${className}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      role="img"
      aria-hidden="true"
      {...rest}
    >
      {render()}
    </svg>
  );
}
